module.exports = __webpack_public_path__ + "img/button_heart_red.5e122f1a.svg";